export enum SignalTypes {
  NOTIFICATION = 'notification',
  SETTINGS_UPDATE = 'settings_update',
  BACKGROUND_TASK_STATE = "background_task_state",
}
